import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import styles from './styles';
import OperationalControlTab from './OperationalControlTab';
import UndergroundMassInputTab from './UndergroundMassInput';
import PF2MTabs from '~/components/PF2MTabs';
import UndergroundCicleAdvanceTab from './UndergroundCicleAdvanceTab';

const OperationalControl = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [UGMassInput, setUGMassInput] = useState(false);
  const { t: translate } = useTranslation();
  const user = useSelector(state => state.auth.user);

  useEffect(() => {
    if (Object.keys(user).find(key => key === 'config')) {
      const checkUgMassInput = user.config.find(e => e.key === 'UG_mass_input')?.value === '1';

      if (!checkUgMassInput) {
        setUGMassInput(false);
        return;
      }

      // se existir a chave ug_mass_input_users no config do usuário,
      // apenas users listados na chave podem ver a aba edição em massa,
      // caso contrário, mantém comportamento padrão
      const checkMassInputUsers = user.config.find(e => e.key === 'UG_mass_input_users');
      if (checkMassInputUsers) {
        const allowedUsers = checkMassInputUsers.value.split(';') || [];
        const isAllowed = allowedUsers.includes(String(user.id));
        setUGMassInput(isAllowed);
      } else {
        // comportamento padrão: apenas usuários níveis 1 e 2 podem ver a aba
        const isAllowed = user.level <= 2;
        setUGMassInput(isAllowed);
      }
    }
  }, [user]);

  const tabs = [
    { key: 0, label: translate('common:OperationalControl') },
    { key: 1, label: translate('common:MassInput'), hidden: !UGMassInput },
    { key: 2, label: translate('common:AdvanceRegister') },
  ];

  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
      >
        {tabs}
      </PF2MTabs>
      {selectedTab === 0 ? (<OperationalControlTab />) : null}
      {selectedTab === 1 && UGMassInput ? (<UndergroundMassInputTab />) : null}
      {selectedTab === 2 ? (<UndergroundCicleAdvanceTab />) : null}
    </>
  );
};

export default withStyles(styles)(OperationalControl);
